import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { TokenStorageService } from "./token.service";

@Injectable({
  providedIn: "root",
})
export class wfsService {
  constructor(
    private http: HttpClient,
    private tokenStorageService: TokenStorageService
  ) {}
  async getAllDraftClasses(obj) {
    let body = {
      target: "getClassDraft",
      query: obj,
      lKey: "WFS",
    };

    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async getAllPublishedClasses(obj) {
    let body = {
      target: "getClassPublish",
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async getAllLists(obj) {
    let body = {
      target: "getLists",
      query: obj,
      lKey: "Lists",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }

  async getSpecificClasses(obj) {
    let rec = {
      classId: obj,
    };
    let body = {
      target: "getClassDraft",
      query: rec,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async getSpecificList(obj) {
    let rec = {
      uuid: obj,
    };
    let body = {
      target: "getLists",
      query: rec,
      lKey: "Lists",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async getSelectedClass(obj) {
    let body = {
      target: "getClassDraft",
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async getECFormsDraft(obj) {
    let body = {
      target: "getFormsDraft",
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async getFormsPublish(obj) {
    let body = {
      // target: "getFormsPublish", query : version, publishId, formId to get specific farm.
      target: "getFormsPublish",
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async getECFormsPublish(obj) {
    let body = {
      // target: "getFormsPublish", query : version, publishId, formId to get specific farm.
      target: "getFormsPublishVersions",
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationReadGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async saveClasses(obj) {
    let body = {
      target: "saveClassDraft",
      source: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async updateClasses(data, selectedUUID) {
    let obj = {
      uuid: selectedUUID,
    };
    let body = {
      target: "updateClasses",
      source: data,
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async saveClassPublish(obj) {
    let body = {
      target: "saveClassPublish",
      source: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }

  async updateList(data, selectedUUID) {
    let obj = {
      uuid: selectedUUID,
    };
    let body = {
      target: "updateLists",
      source: data,
      query: obj,
      lKey: "Lists",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }

  async saveFormsPublish(obj) {
    let body = {
      target: "saveFormsPublish",
      source: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async saveList(obj) {
    let body = {
      target: "saveLists",
      source: obj,
      lKey: "Lists",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async saveClassFormsDraft(obj) {
    let body = {
      target: "saveFormsDraft",
      source: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async updateClassFormsDraft(rec, selectedUUID) {
    let obj = {
      uuid: selectedUUID,
      group: rec.group,
    };
    let body = {
      target: "updateFormsDraft",
      source: rec,
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
  async updateClassDraft(rec, selectedUUID) {
    let obj = {
      uuid: selectedUUID,
      // group: rec.group,
    };
    let body = {
      target: "updateClassDraft",
      source: rec,
      query: obj,
      lKey: "WFS",
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.registrationWriteGateway,
          body,
          this.tokenStorageService.createHttpOptions()
        )
        .subscribe((result) => {
          resolve(result);
        }, reject);
    });
  }
}
